import { z } from 'zod'

export const paramsSchema = z.object({
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>
